export default {
	section_banner: {
		title: {
			one: '결제',
			two: '하기',
			three: '원테더',
		},
		subtitle: {
			one: '빠르고',
			two: '안전한',
			three: '결제',
		},
		cta_buttons: {
			one: '시작하기',
			two: '앱 다운로드',
		},
	},
	section_question: {
		label: '자주 묻는 질문',
		title: {
			one: '언제든지',
			two: '안전한',
			three: '결제',
		},
		description:
			'원테더의 보안은 세계 최고 수준입니다. 귀하의 암호화폐와 디지털 자산을 완벽하게 안전하게 보관하고 안전하게 사용할 수 있도록 도와드립니다.',
		cta_button: '시작하기',
	},
	section_we_offer: {
		label: '원테더 지갑',
		title: {
			one: '어디서나',
			two: '쇼핑을',
			three: '즐기세요',
		},
		description:
			'원테더 지갑에 보관된 암호화폐로 언제 어디서나 원활하고 안전한 거래가 가능합니다. 온라인 쇼핑이든 오프라인 매장에서의 결제든, 원테더는 블록체인 기술을 통해 빠르고 안정적인 결제를 보장합니다.',
		enjoy_shopping: {
			title: '어디서나 쇼핑을 즐기세요',
			subtitle: '원테더 지갑에 보관된 암호화폐로',
			boxes: {
				one: {
					title: '이상적인 암호화폐 지갑',
					description: '원테더에서 원하는 암호화폐 지갑을 만드세요.',
				},
				two: {
					title: '더 스마트한 쇼핑',
					description: '쇼핑하실 때는 원테더를 선택해주세요.',
				},
				three: {
					title: '저희와 함께 결제하세요',
					description: '원테더에서 원하는 암호화폐로 결제하세요.',
				},
			},
			cta_button: '무료 계정 만들기',
		},
	},
	section_online_mid: {
		label: '가장 빠른 결제 시스템',
		title: {
			one: '다시 한 번',
			two: '즐거운',
			three: '경험하세요',
		},
		description:
			'원테더로 구매하시면 다음 구매에 사용할 수 있는 포인트가 적립됩니다. 원테더 포인트는 원테더를 사용하는 모든 가맹점에서 사용 가능하며, 쇼핑과 적립이 쉽고 보람됩니다. 원활한 거래로 매 구매마다 큰 혜택을 누리세요. 또한 원테더 사용자만을 위한 독점 혜택과 할인도 즐기실 수 있습니다.',
		cta_button: '시작하기',
	},
	section_growth: {
		stats: {
			total_customers: {
				value: '80만',
				label: '총 고객 수',
			},
			customer_satisfaction: {
				value: '99.90%',
				label: '고객 만족도',
			},
			money_managed: {
				value: '2,600억',
				label: '관리 자산',
			},
		},
	},
	section_newsletter: {
		label: '뉴스레터 구독',
		title: {
			one: '구독하고',
			two: '최신 소식 받기',
		},
		description: {
			one: '구독하시면 혜택과 업데이트 소식을 받아보실 수 있습니다.',
			two: '원테더 솔루션이 귀하의 비즈니스를 어떻게 성장시킬 수 있는지 문의해 주세요.',
		},
		form: {
			placeholder: '이메일 주소',
			button: '지금 구독하기',
		},
	},
};
